export interface HostedPageInterface {
  url?: string;
  embed?: boolean;
  "created_at"?: number;
  "expires_at"?: number;
  id?: string;
  object?: string;
  "resource_version"?: number;
  state?: string;
  type?: string;
  "updated_at"?: number;
}
